<template>
    <div class="container">
        <div class="nav_header">
            <h2>我的发票</h2>
        </div>

        <el-button icon="el-icon-plus" style="margin-right: 12px;" @click="$router.push('/finance/invoice/apply')">申请发票 </el-button>

        <el-date-picker
            @change="handleDateChange"
            v-model="dateBetween"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="picker_options"
        ></el-date-picker>

        <white-space />

        <div v-loading="loading">
            <el-card
                class="box-card"
                shadow="hover"
                v-for="(item, index) in dataSource"
                :key="index"
                style="margin-bottom:24px;position: relative;"
                :body-style="{ padding: '12px' }"
            >
                <div slot="header" class="card-header">
                    <span class="label">开票日期：{{ item.created_at | dateformat("YYYY-MM-DD HH:mm") }}</span>
                    <span class="label">发票类型：{{ item.invoice_type_text }}</span>
                    <span class="label">开票金额：{{ item.amount }}元</span>
                </div>

                <div class="text item" v-if="item.invoice_type == 'special' || item.invoice_type == 'normal'">
                    <p>
                        <span style="width:50px;display: inline-block;">税点：</span>
                        {{ item.tax_point * 100 }}%

                        <el-divider direction="vertical"></el-divider>

                        <span style="width:50px;display: inline-block;">税额：</span>
                        {{ item.tax_amount }}元
                    </p>
                    <white-space />
                </div>

                <div class="text item">
                    <p v-if="item.status == 0"><i class="el-icon-info" style="color:#FFC107"></i>发票申请已提交，请等待工作人员处理。</p>
                    <p v-if="item.status == 1">
                        <i class="el-icon-success" style="color:#4CAF50"></i>
                        发票已邮寄 • 快递公司：{{ item.express.company }} <el-divider direction="vertical"></el-divider> 单号：{{
                            item.express.no
                        }}
                    </p>
                    <p v-if="item.status == -1">
                        <i class="el-icon-error" style="color:#F44336"></i>
                        开票失败。原因：{{ item.failure_msg }}
                    </p>
                </div>

                <div class="postmark" v-if="item.status == 1">
                    <img src="https://static.711.cn/assets/image/postmark/complete_2.png" />
                </div>
            </el-card>

            <Empty v-if="!dataSource.length" />
        </div>

        <el-pagination
            v-if="dataSource.length"
            style="text-align:center;margin-top:24px;"
            background
            layout="total,prev, pager, next"
            :total="pagination.total"
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            @current-change="handle_current_change"
        ></el-pagination>
    </div>
</template>

<script>
    var requestUrl = "/finance/invoice_list";

    export default {
        data() {
            return {
                loading: false,
                dataSource: [],
                picker_options: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit("pick", [start, end]);
                            },
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit("pick", [start, end]);
                            },
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit("pick", [start, end]);
                            },
                        },
                    ],
                },
                dateBetween: "",
                pagination: {
                    total: 0,
                    per_page: 20,
                    current_page: 1,
                },
            };
        },
        created() {
            this.$store.commit("changeOwnActive", "finance-invoice_list");
            this.load();
            this.parse_query();
        },
        watch: {
            $route() {
                this.load();
                this.parse_query();
            },
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get("/finance/invoice?" + this.objectToQuery(this.$route.query))
                    .then((response) => {
                        if (response.success) {
                            this.dataSource = response.data;
                            this.pagination = response.pagination;
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            parse_query() {
                const query = this.$route.query;
                this.dateBetween = query["created_at"] ? query["created_at"].split(",") : "";
            },
            handleDateChange() {
                var query = JSON.parse(JSON.stringify(this.$route.query));
                query["created_at"] = this.dateBetween ? this.dateBetween.join(",") : "";
                query["_search"] = 1;

                this.$router.push(`/finance/invoice_list?${this.objectToQuery(query)}`);
            },
            handle_current_change(e) {
                var query = JSON.parse(JSON.stringify(this.$route.query));
                query.page = e;
                this.$router.push("/finance/invoice_list?" + this.objectToQuery(query));
            },
        },
    };
</script>

<style lang="less" scoped>
    .text.item {
        font-size: 14px;
    }
    i {
        font-size: 16px;
        margin-right: 12px;
    }
    .label {
        font-size: 14px;
        padding-right: 24px;
        color: #9e9e9e;
    }
    .postmark {
        opacity: 0.7;
        width: 100px;
        height: 100px;
        display: inline-block;
        position: absolute;
        z-index: 1;
        right: 0;
        margin-right: 30px;
        margin-top: -50px;
        top: 50%;
        img {
            width: 100%;
        }
    }
</style>
